import React, { useRef, useEffect, useState } from 'react';
import './BwobMemeScroller.css';

const BwobMemeScroller = () => {
  const firstStripRef = useRef(null);
  const secondStripRef = useRef(null);
  const [paused, setPaused] = useState(false);

  const images = [
    './bwob-art/bwob-schoolboy.png',
    './bwob-art/bwob-bluesky.png',
    './bwob-art/dbz-bwob-cool.png',
    './bwob-art/mcdonalds-bwob.png',
    './bwob-art/gta-bwob.png',
    './bwob-art/bwob-johnwick.png',
    './bwob-art/breaking-bwob.png',
    './bwob-art/mario-bwob.png',
    './bwob-art/zelda-bwob.png',
    './bwob-art/gameboy-bwob.png',
    './bwob-art/pixel-bwob.png',
    './bwob-art/bwob-bluelock.png',
    './bwob-art/L-deathnote-bwob.png',
    './bwob-art/minecraft-bwob.png',
    './bwob-art/bwob-berserk.png',
    './bwob-art/saitama-bwob.png',
    './bwob-art/evangelion-bwob.png',
    './bwob-art/streetwear-bwob.png',
    './bwob-art/high-bwob.png',
    './bwob-art/shocked-bwob.png',
    './bwob-art/bwob-basketball.png',
    './bwob-art/farmer-bwob.png',
    './bwob-art/redpill-bluepill-bwob.png',
    './bwob-art/bwob-godfather.png',
    './bwob-art/lambo-bwob.png',
    './bwob-art/sniper-bwob.png',
    './bwob-art/bwob-slash.png',
    './bwob-art/cultist-bwob.png',
    './bwob-art/mr-robot-bowb.png',
    './bwob-art/greek-bwob.png',
    './bwob-art/presidential-bwob.png',
    './bwob-art/L-bwob.png',
    './bwob-art/bwob-shawty.png',
    './bwob-art/bwob-meditation.png',
    './bwob-art/bwob-sun.png',
    './bwob-art/dbz-bwob.png',
    './bwob-art/bwob-sunset.webp',
    './bwob-art/bwob-supercar.png',
    './bwob-art/bwob-sipping-tea.png',
    './bwob-art/bwob-universe.png',
    './bwob-art/batman-bwob.png',
    './bwob-art/dbz-bwob-pastel.png',
    './bwob-art/bwob-yagami.png',
    './bwob-art/pool-bwob.png',
  ];

  const half = Math.ceil(images.length / 2);
  const firstRowBaseImages = images.slice(0, half);
  const secondRowBaseImages = images.slice(half);

  const secondRowImages = firstRowBaseImages.length > secondRowBaseImages.length ?
    [...secondRowBaseImages, images[0]] :
    secondRowBaseImages;

  const firstRowLoopContent = [...firstRowBaseImages, ...firstRowBaseImages];
  const secondRowLoopContent = [...secondRowImages, ...secondRowImages];

  useEffect(() => {
    const calculateAndSetWidths = () => {
      if (firstStripRef.current && secondStripRef.current) {
        const firstImage = firstStripRef.current.querySelector('.meme-image');

        if (firstImage) {
          const computedStyle = window.getComputedStyle(firstImage);
          const imageMarginRight = parseFloat(computedStyle.marginRight);

          const numberOfImagesInLoopContent = firstRowLoopContent.length;

          const totalContentWidth = (firstImage.offsetWidth * numberOfImagesInLoopContent) + (imageMarginRight * numberOfImagesInLoopContent);

          const scrollDistance = `-${totalContentWidth / 2}px`;

          firstStripRef.current.style.setProperty('--scroll-distance', scrollDistance);
          secondStripRef.current.style.setProperty('--scroll-distance', scrollDistance);

          firstStripRef.current.style.width = `${totalContentWidth}px`;
          secondStripRef.current.style.width = `${totalContentWidth}px`;
        }
      }
    };

    calculateAndSetWidths();

    // Debounce the resize event listener
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(calculateAndSetWidths, 250);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimer);
    };
  }, [firstRowLoopContent, secondRowLoopContent]);

  const getPublicUrl = (path) => (path && path.startsWith('./') ? `/${path.slice(2)}` : path);

  const handleDownload = (imagePath) => {
    const url = getPublicUrl(imagePath);
    const a = document.createElement('a');
    a.href = url;
    a.download = url.split('/').pop() || 'BWOB-image';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="meme-scroller-section">
      <div className="meme-scroller-container">
        <div className={`meme-scroller-strip strip-one ${paused ? 'paused' : ''}`} ref={firstStripRef}>
          {firstRowLoopContent.map((image, index) => (
            <div
              key={`first-${index}`}
              className="meme-item"
              onMouseEnter={() => setPaused(true)}
              onMouseLeave={() => setPaused(false)}
            >
              <img src={getPublicUrl(image)} alt={`BWOB meme ${index + 1}`} className="meme-image" />
              <button
                className="meme-download-btn"
                onClick={(e) => { e.stopPropagation(); handleDownload(image); }}
              >
                Download
              </button>
            </div>
          ))}
        </div>
        <div className={`meme-scroller-strip strip-two ${paused ? 'paused' : ''}`} ref={secondStripRef}>
          {secondRowLoopContent.map((image, index) => (
            <div
              key={`second-${index}`}
              className="meme-item"
              onMouseEnter={() => setPaused(true)}
              onMouseLeave={() => setPaused(false)}
            >
              <img src={getPublicUrl(image)} alt={`BWOB meme ${index + 1}`} className="meme-image" />
              <button
                className="meme-download-btn"
                onClick={(e) => { e.stopPropagation(); handleDownload(image); }}
              >
                Download
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BwobMemeScroller; 